import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Pill } from "./primitives.js";
import { colors } from "./theme.js";
import { eventTypeBadge } from "./event-styles.js";
import { humanizeAuditEntry } from "../../lib/humanize-log.js";
import { formatTimestamp } from "../../lib/format-session.js";
let cssInjected = false;
function ensureRowCss() {
    if (cssInjected)
        return;
    cssInjected = true;
    const sheet = document.createElement("style");
    // Stacks the timestamp/type/message columns on narrow screens instead of
    // forcing a horizontal scroll (the app is a mobile-first PWA).
    sheet.textContent = `
    .ui-audit-row {
      display: grid;
      grid-template-columns: 140px 180px minmax(220px, 1fr);
      gap: 12px;
      align-items: start;
      padding: 10px 12px;
      font-size: 0.8rem;
    }
    @media (max-width: 640px) {
      .ui-audit-row { grid-template-columns: 1fr; gap: 4px; }
    }
  `;
    document.head.appendChild(sheet);
}
/** Resolve a deep-link target for an entry (session takes precedence). */
function deepLinkFor(entry) {
    const meta = (entry.metadata ?? {});
    const sid = entry.sessionId ?? meta.sessionId;
    if (sid)
        return `/sessions/${sid}`;
    const rid = entry.ruleId ?? meta.ruleId;
    if (rid)
        return `/rules/${rid}`;
    return null;
}
/**
 * One audit/log row: timestamp · type pill · humanized message. Single source
 * of truth for the Audit page and the session timeline. When `linkable`, the
 * row links to the related session/rule.
 */
export function AuditRow({ entry, linkable = false, topBorder = true, }) {
    useEffect(() => {
        ensureRowCss();
    }, []);
    const badge = eventTypeBadge(entry.type);
    const to = linkable ? deepLinkFor(entry) : null;
    const inner = (_jsxs("div", { className: "ui-audit-row", style: { borderTop: topBorder ? `1px solid ${colors.divider}` : "none" }, children: [_jsx("span", { style: { color: colors.textTertiary, whiteSpace: "nowrap" }, children: formatTimestamp(entry.ts) }), _jsx("span", { style: { minWidth: 0 }, children: _jsx(Pill, { color: badge.color, style: { whiteSpace: "normal", wordBreak: "break-word" }, children: badge.label }) }), _jsx("span", { style: { color: colors.text, minWidth: 0, overflowWrap: "anywhere" }, children: humanizeAuditEntry(entry) })] }));
    if (!to)
        return inner;
    return (_jsx(Link, { to: to, style: { textDecoration: "none", color: "inherit", display: "block" }, children: inner }));
}
